import {Injectable} from '@angular/core';
import {Tour} from '@app/common/interfaces/tour';

@Injectable({
  providedIn: 'root'
})
export class ShoppingService {

  public shoppedTours: Tour[] = /*getItemStore<Tour[]>('shoppedTours') ||*/ [];
  public shoppedToursIds: string[] = /*getItemStore<string[]>('shoppedToursIds') ||*/ [];
  public totalToursPrice = 0;
  public totalGroupToursPrice = 0;

  constructor() {
    this.getTotalToursPrice();
  }

  public toggleTourOnShop(tour: Tour): void {
    const index: number = this.shoppedTours.findIndex((t: Tour) => t.id === tour.id);
    if (index === -1) {
      this.shoppedTours.push(tour);
      this.shoppedToursIds.push(tour.id);
    } else {
      this.shoppedTours.splice(index, 1);
      this.shoppedToursIds.splice(index, 1);
    }
    // setItemStore<Tour[]>('shoppedTours', this.shoppedTours);
    // setItemStore<string[]>('shoppedToursIds', this.shoppedToursIds);
    this.getTotalToursPrice();
  }

  public isShopExist(tour: Tour): boolean {
    return !!this.shoppedTours.find((t: Tour) => t.id === tour.id);
  }

  public getTotalToursPrice(): void {
    this.totalToursPrice = 0;
    this.totalGroupToursPrice = 0;
    this.shoppedTours.forEach((tour: Tour) => {
      this.totalToursPrice += +tour.price;
      this.totalGroupToursPrice += +tour.groupPrice;
    });
  }

}
